import type { JSX } from 'react';

import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { BaseStyle, Display, JustifyContent } from 'src/styles';

import * as Styles from './ModalField.styles';

interface ModalFieldProps {
  label: string;
  value: JSX.Element | string | number;
  testId?: string;
}

export const ModalField = ({ label, value, testId }: ModalFieldProps) => (
  <Row className={cx(BaseStyle.level, Styles.container, Styles.borderBottom)}>
    <Col span={10} className={cx(Styles.fieldLabel)} data-testid={testId + '-label'}>
      {label}
    </Col>
    <Col
      span={14}
      className={cx(Styles.alignRight, Styles.fieldValue, Display.flex, JustifyContent.flexEnd)}
      data-testid={testId + '-value'}>
      {value}
    </Col>
  </Row>
);
